import { Text, UI, HStack, VStack } from '@genial/components';
import { Spacing, Typography } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import { Box } from 'native-base';
import React from 'react';
import { Control, useFormContext, useWatch } from 'react-hook-form';

import { ApplicationRangeFormData } from '../..';

interface InputApplicationRangeProps {
  label?: string;
}
export const InputApplicationRange: React.FC<InputApplicationRangeProps> = ({ label }) => {
  const { control } = useFormContext<ApplicationRangeFormData>();

  const minAppliedAmount = useWatch({
    control,
    name: 'minAppliedAmount',
  });

  const maxAppliedAmount = useWatch({
    control,
    name: 'maxAppliedAmount',
  });

  const isError = Utils.Unmask.Money(minAppliedAmount) > Utils.Unmask.Money(maxAppliedAmount);

  return (
    <VStack pb={Spacing['stack.xxxs']}>
      <Text variant="semibold" fontSize={Typography['fontsize.md']}>
        {label || 'Aplicação Mínima'}
      </Text>

      <HStack w={'full'} pt={Spacing['stack.xxxs']} alignItems={'center'}>
        <Box flex={1}>
          <UI.Input
            testId={'minApplicationAmount'}
            name={'minAppliedAmount'}
            autoComplete="off"
            control={control as unknown as Control}
            hasShadow={false}
            variant="filled"
            placeholder="R$ 0,00"
            keyboardType="numeric"
            mask={Utils.Mask.InputMoney}
          />
        </Box>
        <Box width="10px" bg="neutral.medium" h={'1px'} mx={Spacing['inset.nano']} />
        <Box flex={1}>
          <UI.Input
            testId={'maxApplicationAmount'}
            name={'maxAppliedAmount'}
            autoComplete="off"
            control={control as unknown as Control}
            hasShadow={false}
            placeholder="+ R$ 10.000.000,00"
            variant="filled"
            keyboardType="numeric"
            mask={Utils.Mask.InputMoney}
          />
        </Box>
      </HStack>

      {isError && (
        <Text
          pt={Spacing['stack.quarck']}
          variant="regular"
          fontSize={Typography['fontsize.xs']}
          color={'feedback.error.default'}>
          O valor mínimo deve ser menor que o valor máximo
        </Text>
      )}
    </VStack>
  );
};
